import React from 'react';
import Books from '../components/Books';
import SectionTitle from '../components/SectionTitle';
import { Grid, Row } from 'react-bootstrap';
import config from "../config";
import store from '../store';

class BooksListContainer extends React.Component {
    constructor(props){
        super(props);
        store.dispatch(this.props.fetchBookDetails(config.author));
        store.dispatch(this.props.fetchBooksPageData(config.author));
    }
    render(){
        return (
            <div>
                <div className="page-title bg-grey">
                    {this.props.books.length ? <SectionTitle title={this.props.books[0].pageTitle}/> : null }
                </div>
                <Grid>
                    <Row className="show-grid">
                        <div className="page-content">
                            {this.props.books.length && this.props.booksData.length ? this.props.books[0].books.map((book, i) => <Books {...this.props} key={i} i={i} book={this.props.booksData[0].books.find(x=>x._doc===book.id)} />) : null}
                        </div>
                    </Row>
                </Grid>
            </div>
        )
    }
}

export default BooksListContainer;


// WEBPACK FOOTER //
// ./src/containers/BooksListContainer.js